"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customizeTheme = exports.customStyleObj = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//based off: https://react-select.com/styles#style-object

/* eslint-disable complexity */
var customStyleObj = function customStyleObj(props) {
  return R.mergeDeepRight({
    container: function container(base) {
      return _objectSpread({}, base, {
        display: 'flex',
        justifyContent: 'center',
        height: props.size === 'large' ? "".concat(props.theme.spacing[6], "px") : props.theme.input.height
      });
    },
    clearIndicator: function clearIndicator(base) {
      return _objectSpread({}, base, {
        padding: '0 8px',
        ':hover': {
          cursor: 'pointer',
          color: props.theme.input.clearIndicator.hover
        }
      });
    },
    control: function control(base, state) {
      return _objectSpread({}, base, {
        width: '100%',
        minHeight: props.theme.input.height,
        '&:hover': {
          cursor: 'pointer',
          boxShadow: props.theme.input.shadow,
          borderColor: props.hasError ? props.theme.input.error.border : props.theme.input.border
        },
        backgroundColor: props.hasError ? props.theme.input.error.background : props.isDisabled ? props.theme.input.disabled.background : 'white',
        boxShadow: state.isFocused ? props.theme.container.shadow[6] : 'none',
        borderColor: props.hasError ? props.theme.input.error.border : state.isFocused ? props.theme.colors.primary[0] : props.theme.input.border,
        borderRadius: state.menuIsOpen ? "".concat(props.theme.input.radius, " ").concat(props.theme.input.radius, " 0 0") : props.theme.input.radius
      });
    },
    group: function group(base) {
      return _objectSpread({}, base, {
        marginLeft: props.theme.typeahead.group.leftIndent
      });
    },
    groupHeading: function groupHeading(base) {
      return _objectSpread({}, base, {
        fontSize: props.theme.typeahead.groupHeading.fontSize,
        color: props.theme.typeahead.groupHeading.color,
        textTransform: 'capitalize',
        marginLeft: props.theme.typeahead.groupHeading.leftIndent
      });
    },
    indicatorsContainer: function indicatorsContainer(base) {
      return _objectSpread({}, base, {
        marginTop: '1px'
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    menu: function menu(base) {
      return _objectSpread({}, base, {
        fontSize: props.theme.input.fontSize,
        marginTop: '0',
        borderRadius: "0 0 ".concat(props.theme.input.radius, " ").concat(props.theme.input.radius),
        width: 'calc(100% - 2px)',
        minWidth: props.decorator === 'individual' ? '300px' : '0',
        left: '0'
      });
    },
    menuList: function menuList(base) {
      return _objectSpread({}, base, {
        padding: '0'
      });
    },
    multiValueLabel: function multiValueLabel(base) {
      return _objectSpread({}, base, {
        color: 'white',
        backgroundColor: props.isDisabled ? props.theme.input.disabled.optionLabelBackground : props.theme.colors.primary[0],
        borderRadius: '3px 0 0 3px',
        fontSize: props.theme.typeahead.multiValueLabel.fontSize,
        lineHeight: props.theme.typeahead.multiValueLabel.lineHeight
      });
    },
    multiValueRemove: function multiValueRemove(base) {
      return _objectSpread({}, base, {
        color: props.theme.colors.white,
        backgroundColor: props.isDisabled ? props.theme.input.disabled.optionLabelBackground : props.theme.colors.primary[0],
        borderRadius: '0 3px 3px 0',
        ':hover, :focus': {
          color: 'white',
          backgroundColor: props.isDisabled ? props.theme.input.disabled.optionLabelBackground : props.theme.colors.primary[0],
          cursor: 'pointer'
        }
      });
    },
    placeholder: function placeholder(base) {
      return _objectSpread({}, base, {
        fontSize: props.theme.input.fontSize,
        color: props.hasError ? props.theme.input.error.placeholderFontColor : props.theme.input.disabled.placeholderFontColor,
        marginLeft: props.isMulti ? '10px' : '2px',
        width: '100%',
        paddingRight: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      });
    },
    input: function input(base) {
      return _objectSpread({}, base, {
        fontSize: props.theme.input.fontSize,
        input: {
          height: 'inherit'
        },
        marginLeft: props.isMulti ? '10px' : '2px',
        lineHeight: props.isMulti ? props.theme.typeahead.multiValueLabel.lineHeight : props.theme.input.lineHeight,
        '& input[type="text"]': {
          minHeight: 0,
          marginBottom: 0,
          lineHeight: 'inherit',
          '&:focus': {
            boxShadow: 'none'
          }
        },
        marginBottom: 0
      });
    },
    option: function option(base, state) {
      return _objectSpread({}, base, {
        display: 'flex',
        alignItems: 'center',
        color: state.isDisabled ? props.theme.input.disabled.color : state.isSelected ? 'white' : props.theme.input.fontColor,
        width: "calc(100% + ".concat(props.theme.typeahead.group.leftIndent, ")"),
        position: 'relative',
        right: props.theme.typeahead.group.leftIndent,
        padding: "".concat(props.theme.typeahead.group.leftIndent, " 20px"),
        ':hover': {
          cursor: state.data.isLink && state.isDisabled ? 'default' : state.isDisabled ? 'not-allowed' : 'pointer'
        },
        '> svg': {
          fill: state.isSelected ? 'white' : props.theme.input.fontColor
        }
      });
    },
    singleValue: function singleValue(base) {
      return _objectSpread({}, base, {
        fontSize: props.theme.input.fontSize,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'flex',
        alignItems: 'center'
      });
    },
    valueContainer: function valueContainer(base) {
      return _objectSpread({}, base, {
        padding: props.isMulti ? '2px' : '0 10px',
        marginLeft: '1px' // lines up the single selected value with the dropdown

      });
    }
  }, _objectSpread({}, props.customStyles));
};
/* eslint-enable complexity */


exports.customStyleObj = customStyleObj;

var customizeTheme = function customizeTheme(theme, props) {
  return _objectSpread({}, theme, {
    colors: {
      danger: props.theme.input.error.fontColor,
      dangerLight: props.theme.input.error.background,
      neutral0: props.theme.colors.white,
      neutral5: props.theme.colors.neutral[6],
      neutral10: props.theme.colors.neutral[5],
      neutral20: props.theme.colors.neutral[4],
      neutral30: props.theme.colors.neutral[3],
      neutral40: props.theme.colors.neutral[3],
      neutral50: props.theme.colors.neutral[2],
      neutral60: props.theme.colors.neutral[2],
      neutral70: props.theme.colors.neutral[1],
      neutral80: props.theme.colors.neutral[0],
      neutral90: props.theme.colors.neutral[0],
      primary: props.theme.colors.primary[0],
      primary25: props.theme.colors.primary[3],
      primary50: props.theme.colors.primary[2],
      primary75: props.theme.colors.primary[0]
    },
    iconSize: props.theme.spacing[3]
  });
};

exports.customizeTheme = customizeTheme;